import { Product } from '@df/catalog/product/product';
import { Exponea } from '@df/module-exponea/exponea.types';
import { NgInject } from '@df/ng/ng-inject';
import take from 'lodash-es/take';
import { ModelCarouselEngine } from '../../catalog/ui/page/component/model-carousel/model-carousel-engine';
import { IModelCarouselLoadRequest } from '../../catalog/ui/page/component/model-carousel/model-carousel.interface';
import { ModelCarouselService } from '../../catalog/ui/page/component/model-carousel/model-carousel.service';
import { ExponeaService } from './exponea.service';

interface IExponeaRecommendationsModelCarouselLoadRequest extends IModelCarouselLoadRequest {
    exponeaOptions?: string;
}

export class ExponeaRecommendationsModelCarouselEngine extends ModelCarouselEngine<Product> {
    @NgInject(ExponeaService)
    protected exponeaService!: ExponeaService;

    get(type: string, data: IExponeaRecommendationsModelCarouselLoadRequest): Promise<Product[]> {
        return new Promise(resolve => {
            const options = data?.exponeaOptions;
            if (options) {
                this.exponeaService
                    .loadRecommendationsProducts(options)
                    .then(products => {
                        resolve(data.limit ? take(products, data.limit) : products);
                    })
                    .catch(() => {
                        resolve([]);
                    });
            } else {
                resolve([]);
            }
        });
    }
}

ModelCarouselService.engines[Exponea.recommendationsEngineId] = new ExponeaRecommendationsModelCarouselEngine();
